import { PushNotificationsService } from "@app/core/notifications/domain/push-notifications.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * Fake implementation of PushNotificationsService.
 * It does nothing.
 */
@Injectable()
export class FakePushNotificationService implements PushNotificationsService {
  onNotificationOpen$ = new Observable() as any;
  onSubscriptionChange$ = new Observable() as any;
  onNotificationReceived$ = new Observable() as any;

  init(): void {
    // do nothing
  }

  requestPermissions(): Observable<boolean> {
    return new Observable() as any;
  }

  enableNotifications(): void {
    // do nothing
  }
}
